module.exports = __webpack_public_path__ + "media/images/ecute/ecuteueno_zh-hant-ce33143670b815a2b754d62a952ee7bd.jpg";